import { useFichasTabela } from "./use-fichas-tabela";
import { FichasTabelaView } from "./view-fichas-tabela";
import type { FichasTabelaProps } from "./types-fichas-tabela";

export function FichasTabela(props: FichasTabelaProps) {
  const vm = useFichasTabela(props);

  return <FichasTabelaView {...vm} />;
}

export type * from "./types-fichas-tabela";
